<template>
  <!-- ログイン画面以外では常に表示しているメニューバー。
  画面サイズの'small', 'medium', 'large'の３段階に合わせて表示方法が変わる。
  ログイン時は常に表示しているため、これが消える時は「ログアウト」、または「アプリ終了」になるので、ローカルデータのクリーンアップのトリガーもここに入っている。-->
  <v-navigation-drawer
    id="app-drawer"
    v-model="isDrawerVisible"
    :mini-variant="isShrank"
    mini-variant-width="60"
    dark
    floating
    fixed
    persistent
    mobile-break-point="991"
    width="230"
    class="nav-drawer"
  >
    <div
      style="height: 100%;"
      @mouseenter="expanded = true"
      @mouseleave="expanded = false"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <div style="text-align:left;padding-top:10px">
          <img
            src="@/../public/img/logo-white-525.png"
            alt="GONOW"
            class="logo"
            :class="shrinkClass"
          >
        </div>
        <v-divider
          style="display:block!important"
          class="divider mb-0"
          :class="shrinkClass"
        />
        <v-list-tile>
          <v-list-tile-title
            style="font-size:16px!important;text-align: center;"
            v-text="companyName"
          />
        </v-list-tile>
        <v-divider
          style="display:block!important"
          class="divider"
          :class="shrinkClass"
        />
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          avatar
          active-class=""
          class="v-list-item mx-0"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>
        <v-spacer />
        <v-list-tile-title
          v-if="!isShrank"
          class="version"
          style="font-size:16px!important"
          v-text="'ver.'+' '+version"
        />
      </v-layout>
    </div>
  </v-navigation-drawer>
</template>

<script>
import {
  mapMutations,
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import { version } from '../../../package.json'
import links from './data/links'

export default {
  name: 'AppDrawer',
  data () {
    return {
      version,
      expanded: false
    }
  },
  computed: {
    ...mapState('app', ['user', 'company']),
    ...mapState('display', ['drawer', 'screenSize']),
    ...mapGetters('app', ['disabledPathNames']),
    isShrank () {
      return !this.expanded && this.screenSize === 'medium'
    },
    companyName () {
      return this.isShrank
        ? ''
        : this.company.name
    },
    shrinkClass () {
      return this.isShrank
        ? 'shrink'
        : 'expanded'
    },
    isDrawerVisible: {
      get () {
        return this.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    /**
     * ユーザーの権限に応じて表示するルートを返す。
     * @return {{to: String, icon: String, text: String}[]}
     */
    links () {
      return links.filter(l => !this.disabledPathNames.includes(l.text))
    }
  },

  mounted () {
    // ユーザーがwindow幅を変える度に新しい幅に合わせて'small', 'medium', 'large'の状態を持つ。
    window.addEventListener('resize', this.windowResize)
    this.updateScreenState(window.innerWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResize)
    // ユーザーが「ログアウトする」、「アプリを閉じる」ときにVuexのデータをクリアする。
    this.$store.dispatch('app/clearAppData')
  },
  methods: {
    ...mapMutations('display', ['setDrawer', 'toggleDrawer']),
    ...mapActions('display', ['updateScreenState']),
    windowResize () {
      this.updateScreenState(window.innerWidth)
    }
  }
}
</script>

<style lang="scss" scoped>
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    /deep/.v-list .v-list-item .v-list__tile.v-list__tile--active {
      background-color: #eee;
      color: var(--metal-blue-d);
      box-shadow: none !important;
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
      overflow-y: auto;
    }
  }
  .version {
    flex-grow: 0 !important;
    text-align: right !important;
    font-weight: 100 !important;
    padding-right: 15px !important;
  }
  .logo{
    height: 70px;
    transform: scaleX(1);
    transform-origin: left;
    transition: transform 0.2s;
    &.shrink{
      transform: scaleX(0);
    }
  }
  .divider{
    transform-origin: left;
    &.shrink{
      transform: scaleX(0);
    }
  }
  .nav-drawer{
    z-index: 100;
    background-color: var(--metal-blue-d);
  }
</style>
